import "./styles/variables.css"; //load first
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./locales/i18n"; // Initialize i18n

// Silence non-error logs in production while keeping errors visible
if (process.env.NODE_ENV === "production") {
    const noop = () => {};
    console.log = noop;
    console.info = noop;
    console.debug = noop;
    console.trace = noop;
    console.warn = noop;
}

// Set a simple cookie to signal JS-enabled client for server human gate
(function setJsVerifiedCookie() {
    try {
        var exists = document.cookie && document.cookie.indexOf('js_verified=1') !== -1;
        if (!exists) {
            var oneYear = 60 * 60 * 24 * 365;
            document.cookie = "js_verified=1; path=/; max-age=" + oneYear + "; SameSite=Lax";
        }
    } catch (e) {
        // no-op: cookie write failures should not break app init
    }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
